import { render, staticRenderFns } from "./homehelp.vue?vue&type=template&id=67ef9448&scoped=true&lang=html"
import script from "./homehelp.vue?vue&type=script&lang=js"
export * from "./homehelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ef9448",
  null
  
)

export default component.exports